import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import itTranslation from "./locales/it/translation.json";
import frTranslation from "./locales/fr/translation.json";

// Letto da chi conosce il country dell'utente (es. dopo il login) prima
// che i18next risolva la lingua. Impostare con:
//   localStorage.setItem("userCountryLang", user.country === "FR" ? "fr" : "it")
const userCountryDetector = {
  name: "userCountry",
  lookup() {
    return localStorage.getItem("userCountryLang") || undefined;
  },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(userCountryDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: itTranslation },
      fr: { translation: frTranslation },
    },
    supportedLngs: ["it", "fr"],
    fallbackLng: "it",
    detection: {
      order: ["querystring", "userCountry", "localStorage", "navigator"],
      lookupQuerystring: "lang",
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
